import { useSearchParams } from "react-router-dom";
import { Box, Typography, Paper } from "@mui/material";
import { colorPrimaryDark } from "../../rsc/colors";
import { ReactComponent as PempemLogo } from "../../rsc/logo.svg";
import { useEffect, useState } from "react";
import axios from "axios";
import { Loader } from "../../component/Loader";
import { REDIRECT_URL_ANDROID } from "../../helper/helper";
import { t } from "i18next";

type State = {
    loading: boolean
    isSuccess?: boolean
    error?: string
}

function MailVerification() {

    const [state, setState] = useState<State>({
        loading: false,
        isSuccess: undefined
    })

    const [param] = useSearchParams();
    const email = param.get("email");
    const oob = param.get("oob");

    useEffect(() => {
        const data = {
            "oob": oob,
            "email": decodeURIComponent(email ?? "")
        }

        setState({
            loading: true,
            isSuccess: undefined
        })

        axios.post(`${process.env.REACT_APP_BASE_URL_PUBLIC}/auth/welcome/verifyEmail`, data, {
            withCredentials: false,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                "x-app-name": "welcome",
                "x-app-id": process.env.REACT_APP_APP_ID,
            }
        }).then(() => {
            setState({
                loading: false,
                isSuccess: true
            })
            setTimeout(() => {
                window.location.href = REDIRECT_URL_ANDROID;
            }, 1000)
        }).catch(e => {
            setState({
                loading: false,
                isSuccess: false,
                error: e.response.data.message ?? e.message
            })
        })
        // eslint-disable-next-line
    }, [])

    return (
        <Box
            minHeight="100vh"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            p={2}
        >
            <Paper
                elevation={3}
                sx={{
                    textAlign: "center",
                    px: 4,
                    py: 6,
                    borderRadius: 2,
                    maxWidth: 400,
                    width: "100%",
                }}
            >
                <Box display="flex" justifyContent="center" mb={3}>
                    <PempemLogo fill={colorPrimaryDark} style={{ height: 60 }} />
                </Box>
                {
                    state.error === "EXPIRED" ?
                        <Typography variant="h5" sx={{ marginTop: '10px' }} gutterBottom>
                            {t("link_expired")}
                        </Typography>
                        :
                        <>
                            <Typography variant="h5" gutterBottom>
                                {
                                    state.loading === true ? t("verifying_email") : state.isSuccess === true ? t("email_verified_success_title") : t("an_error_occured")
                                }
                            </Typography>
                            <Typography variant="body1">
                                {
                                    state.loading === true ? "..." : state.isSuccess === true ? t("email_verified_success_message") : t("an_error_occured")
                                }
                            </Typography>
                        </>
                }
            </Paper>
            <Loader isLoading={state.loading} />
        </Box>
    );
}

export default MailVerification;